// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import EndpointsTestingComponent from './endpointsTestingComponent'
import Loading from '../../components-lib/loading'
import ErrorMessage from '../../components-lib/errorMessage'
import Success from '../../components-lib/success'
import {useAxios} from '../../hooks/useAxios'
    export default
        function GetConnectionTokenTestingEndpoints(
        props
        )
        {
            const [{response: connectionToken, isLoading: connectionTokenLoading, error: connectionTokenError}, connectionTokenFetch, connectionTokenClear] = useAxios()
            const connectionTokenPost = 
                (connectionTokenParams, responseCallback, errorCallback, cancelCallback) => {
                    connectionTokenFetch({
                        url: `/Proxy/GetConnectionToken`,
                        data: connectionTokenParams,
                        method: "post",
                        responseCallback,
                        errorCallback,
                        cancelCallback
                    });
                }
            function mainRender() {
                return (
                    <div className='container-lg'>
                        <div className='display-4'>GetConnectionTokenTestingEndpoints</div>
                    </div>
                )
            }
            return (
                <>
                    {mainRender()}
                    {connectionTokenLoading && <Loading isSaving/>}
                    {connectionTokenError && <ErrorMessage error={connectionTokenError} fetchForInit={connectionTokenClear}/>}
                    {connectionToken && <Success/>}
                    <EndpointsTestingComponent
                        connectionToken={connectionToken}
                        onConnectionTokenPost={connectionTokenPost}
                        onConnectionTokenClear={connectionTokenClear}
                        {...props}
                    />
                </>
            )
        }
